<template>
    <select
        @change="valueChanged"
        class="form-control"
        :value="value"
    >
        <option
            disabled
            :hidden="required"
            :selected="!value"
            value=""
            v-if="placeholder"
            v-text="placeholder"
        ></option>
        <option
            :key="option[valueKey]"
            :value="option[valueKey]"
            v-for="option in options"
            v-text="option[labelKey]"
        ></option>
    </select>
</template>

<script>
export default {
    name: 'SelectInput',

    props: {
        labelKey: {
            default: 'name',
            required: false,
            type: String,
        },
        options: {
            required: true,
            type: Array,
        },
        placeholder: {
            default: null,
            required: false,
            type: String,
        },
        required: {
            default: false,
            required: false,
            type: Boolean,
        },
        value: {
            default: null,
            required: false,
            type: [String, Number],
        },
        valueKey: {
            default: 'id',
            required: false,
            type: String,
        },
    },

    methods: {
        valueChanged(e) {
            this.$emit('input', e.target.value);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/SelectInput.vue